'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.options = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _interactionListTextItem = require('lemon-db/dist/options/interactionListTextItem.json');

var _interactionListTextItem2 = _interopRequireDefault(_interactionListTextItem);

var _formatLink = require('../../util/formatLink');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _normal = require('./_normal.scss');

var _normal2 = _interopRequireDefault(_normal);

var _emojiMart = require('emoji-mart');

var _hoc = require('../../hoc');

var _reactCssThemr = require('react-css-themr');

var _reactSpring = require('react-spring');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Hocs
// Animation


var options = exports.options = _interactionListTextItem2['default'];

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      TextEditor = _ref.TextEditor;

  var TextAnswer = function (_React$Component) {
    _inherits(TextAnswer, _React$Component);

    function TextAnswer() {
      _classCallCheck(this, TextAnswer);

      return _possibleConstructorReturn(this, (TextAnswer.__proto__ || Object.getPrototypeOf(TextAnswer)).apply(this, arguments));
    }

    _createClass(TextAnswer, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            link = _props.link,
            animationStyles = _props.animationStyles;

        if (animationStyles) {
          return this.animatedAnswerComponent;
        }

        if (link) {
          return this.linkedAnswerComponent;
        }

        return this.answerComponent;
      }
    }, {
      key: 'formattedLink',
      get: function get() {
        var link = this.props.link;
        return (0, _formatLink.formatLink)(link);
      }
    }, {
      key: 'answerClass',
      get: function get() {
        var _cn;

        var _props2 = this.props,
            theme = _props2.theme,
            bouncy = _props2.bouncy,
            editable = _props2.editable;
        return (0, _classnames2['default'])(theme.textAnswer, (_cn = {}, _defineProperty(_cn, theme.bouncy, bouncy), _defineProperty(_cn, theme.editable, editable), _cn));
      }
    }, {
      key: 'answerStyle',
      get: function get() {
        var _props3 = this.props,
            bgColor = _props3.bgColor,
            color = _props3.color;
        var style = {};
        style.backgroundColor = bgColor;
        style.color = color;
        return style;
      }
    }, {
      key: 'textComponent',
      get: function get() {
        var _props4 = this.props,
            draft = _props4.draft,
            theme = _props4.theme,
            size = _props4.size,
            rest = _objectWithoutProperties(_props4, ['draft', 'theme', 'size']);

        var textClass = (0, _classnames2['default'])(theme.text, theme[size]);
        return _react2['default'].createElement('div', {
          className: textClass
        }, _react2['default'].createElement(TextEditor, _extends({
          align: 'left',
          draft: draft,
          inherit: true
        }, rest, {
          boxed: false
        })));
      }
    }, {
      key: 'emojiComponent',
      get: function get() {
        var _props5 = this.props,
            emoji = _props5.emoji,
            theme = _props5.theme,
            onEmojiClick = _props5.onEmojiClick,
            editable = _props5.editable;
        var emojiClass = (0, _classnames2['default'])(theme.emoji, 'preventClickOutside', _defineProperty({}, theme.editable, editable));
        if (!emoji) return null;
        return _react2['default'].createElement('div', {
          className: emojiClass,
          onClick: onEmojiClick
        }, _react2['default'].createElement(_emojiMart.Emoji, {
          emoji: emoji,
          size: 20,
          "native": true
        }));
      }
    }, {
      key: 'answerComponent',
      get: function get() {
        var _props6 = this.props,
            clickHandler = _props6.clickHandler,
            externalRef = _props6.externalRef;
        return _react2['default'].createElement('div', {
          className: this.answerClass,
          onClick: clickHandler,
          style: this.answerStyle,
          ref: externalRef
        }, this.emojiComponent, this.textComponent);
      }
    }, {
      key: 'animatedAnswerComponent',
      get: function get() {
        var _props7 = this.props,
            animationStyles = _props7.animationStyles,
            clickHandler = _props7.clickHandler;
        return _react2['default'].createElement(_reactSpring.animated.div, {
          style: animationStyles
        }, _react2['default'].createElement('div', {
          className: this.answerClass,
          onClick: clickHandler,
          style: this.answerStyle
        }, this.emojiComponent, this.textComponent));
      }
    }, {
      key: 'linkedAnswerComponent',
      get: function get() {
        var theme = this.props.theme;
        return _react2['default'].createElement('a', {
          href: this.formattedLink,
          target: '_blank',
          rel: 'noopener noreferrer',
          className: theme.linkWrapper
        }, this.answerComponent);
      }
    }]);

    return TextAnswer;
  }(_react2['default'].Component);

  TextAnswer.themeShape = {
    textAnswer: _propTypes2['default'].string,
    linkWrapper: _propTypes2['default'].string,
    bouncy: _propTypes2['default'].string,
    emoji: _propTypes2['default'].string
  };
  TextAnswer.displayName = identifier;
  TextAnswer.propTypes = {
    theme: _propTypes2['default'].shape(TextAnswer.themeShape),
    size: _propTypes2['default'].oneOf(Object.values(options.sizes)),
    bgColor: _propTypes2['default'].string,
    color: _propTypes2['default'].string,
    link: _propTypes2['default'].string,
    emoji: _propTypes2['default'].string,
    clickHandler: _propTypes2['default'].func,
    onEmojiClick: _propTypes2['default'].func,
    bouncy: _propTypes2['default'].bool,
    editable: _propTypes2['default'].bool,
    animationStyles: _propTypes2['default'].object,
    externalRef: _propTypes2['default'].object,
    draft: _propTypes2['default'].object.isRequired
  };
  TextAnswer.defaultProps = {
    box: {
      left: 'none',
      right: 'none',
      top: 'small',
      bottom: 'small',
      bgColor: 'transparent'
    },
    link: '',
    bgColor: '',
    color: '',
    animationStyles: undefined,
    bouncy: false,
    editable: false,
    emoji: '',
    externalRef: _react2['default'].createRef(),
    size: 'small'
  };
  var themed = (0, _reactCssThemr.themr)(identifier, _normal2['default'])(TextAnswer);
  var limited = (0, _hoc.limitedWidth)(themed);
  return (0, _hoc.Boxed)(true)(limited);
};

exports['default'] = factory;